import { fontStyles } from '../../styles/typography';

// Shared typography styles for AboutMatcha child components
export const sectionTitleClass = fontStyles({
  variant: 'H2',
  class: 'text-token-gray-1600 leading-[110%]',
});
